import styled from 'styled-components/macro';

import { NextButton } from '../../../common/buttonsComponents';

export const CopyButtonWrapper = styled.div`
  z-index: 2;
  background: #fff;
`;

export const DecisionFlowDummyButton = styled(NextButton)`
  margin-right: 30px;
`;
